import React, { useState, useEffect } from 'react';
import { pie } from 'd3';

import DEIPageDonutChartSlice from './DEIPageDonutChartSlice/DEIPageDonutChartSlice';
import DEIPageCounter from '../../DEIPageCounter/DEIPageCounter';

import {
  DEIPageDonutChartDIV,
  DEIPageDonutChartCIRCLE,
  DEIPageDonutChartPercentageOverlayDIV,
} from './DEIPageDonutChart.styles';

const EMPTY_PIE_SLICES = Array(4).fill(null).map(() => ({ value: 0 }));

const DEIPageDonutChart = ({
  activePieSliceIndex,
  colors,
  id,
  percentages,
  setActivePieSliceIndex,
}) => {
  const [pieSlices, setPieSlices] = useState(EMPTY_PIE_SLICES);
  const [showPercentage, setShowPercentage] = useState(false);
  const radius = 240;

  useEffect(() => {
    const makePie = pie()
      .value(d => Number(d.percentage))
      .sort((a, b) => a.title.localeCompare(b.title))
      .startAngle(-0.5);
    const _pieSlices = makePie(percentages);

    setPieSlices(_pieSlices);
  }, [percentages]);

  useEffect(() => {
    if (activePieSliceIndex !== null) {
      setShowPercentage(true);
    } else {
      setShowPercentage(false);
    }
  }, [activePieSliceIndex]);

  return (
    <DEIPageDonutChartDIV>
      <svg
        width={radius * 2}
        height={radius * 2}
        viewBox={`0 0 ${radius * 2} ${radius * 2}`}
        onMouseLeave={() => setActivePieSliceIndex(null)}
      >
        <defs>
          {colors.map((color, i) => (
            <pattern
              height="100%"
              id={`${id}-image-${i}`}
              key={i}
              width="100%"
            >
              <image href={color.PATTERN_L} x="0" y="0" width={radius * 2} height={radius * 2} />
            </pattern>
          ))}
          {pieSlices.map((pieSlice, i) => (
            <mask
              height={radius * 2}
              id={`${id}-mask-${i}`}
              key={i}
              width={radius * 2}
              x="0"
              y="0"
            >
              <DEIPageDonutChartSlice
                id={`${id}-mask-${i}-path`}
                isZoomed={activePieSliceIndex === i}
                radius={radius}
                data={{
                  ...pieSlice,
                  innerRadius: 0,
                  outerRadius: radius - 10,
                }}
              />
            </mask>
          ))}
        </defs>
        <g>
          {pieSlices.map((_, i) => (
            <rect
              key={i}
              fill={`url(#${id}-image-${i})`}
              height={radius * 2}
              mask={`url(#${id}-mask-${i})`}
              width={radius * 2}
              x="0"
              y="0"
            />
          ))}
        </g>
        <g>
          {pieSlices.map((_, i) => (
            <use
              key={i}
              href={`#${id}-mask-${i}-path`}
              onMouseEnter={() => setActivePieSliceIndex(i)}
              x="0"
              y="0"
              style={{
                cursor: 'pointer',
                opacity: 0,
              }}
            />
          ))}
        </g>
        <g>
          <DEIPageDonutChartCIRCLE
            cx={radius}
            cy={radius}
            fill="white"
            r={showPercentage ? 150 : 50}
          />
        </g>
      </svg>
      {activePieSliceIndex !== null && pieSlices[activePieSliceIndex].data && (
        <DEIPageDonutChartPercentageOverlayDIV>
          <h4 className="font--display-L">
            <DEIPageCounter value={pieSlices[activePieSliceIndex].data.percentage} />%
          </h4>
          <p>{pieSlices[activePieSliceIndex].data.title}</p>
        </DEIPageDonutChartPercentageOverlayDIV>
      )}
    </DEIPageDonutChartDIV>
  );
}

export default DEIPageDonutChart;
